import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export var Fallback = function Fallback() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "w-full max-w-sm p-4 mx-auto border border-blue-300 rounded-md shadow",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex space-x-4 animate-pulse",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-10 h-10 rounded-full bg-slate-200"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-1 py-1 space-y-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "h-2 rounded bg-slate-200"
          }), /*#__PURE__*/_jsxs("div", {
            className: "space-y-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "grid grid-cols-3 gap-4",
              children: [/*#__PURE__*/_jsx("div", {
                className: "h-2 col-span-2 rounded bg-slate-200"
              }), /*#__PURE__*/_jsx("div", {
                className: "h-2 col-span-1 rounded bg-slate-200"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "h-2 rounded bg-slate-200"
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full max-w-sm p-4 mx-auto border border-blue-300 rounded-md shadow",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex space-x-4 animate-pulse",
        children: [/*#__PURE__*/_jsx("div", {
          className: "w-10 h-10 rounded-full bg-slate-200"
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-1 py-1 space-y-6",
          children: [/*#__PURE__*/_jsx("div", {
            className: "h-2 rounded bg-slate-200"
          }), /*#__PURE__*/_jsxs("div", {
            className: "space-y-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "grid grid-cols-3 gap-4",
              children: [/*#__PURE__*/_jsx("div", {
                className: "h-2 col-span-2 rounded bg-slate-200"
              }), /*#__PURE__*/_jsx("div", {
                className: "h-2 col-span-1 rounded bg-slate-200"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: "h-2 rounded bg-slate-200"
            })]
          })]
        })]
      })
    })]
  });
};